import classNames from 'classnames';
import { Row } from '@tanstack/react-table';
import React, { memo, ReactNode } from 'react';
import { DataGridRowProps } from '@components/primitives/dataGrid/DataGrid';

interface RowProps {
    className?: string;
}

interface Props<TData> {
    row: Row<TData>;
    isSelected: boolean;
    setActiveRow?: (activeRow: string | undefined, index: number) => void;
    children: ReactNode;
    getRowProps?: (row: Row<TData>) => RowProps;
    index: number;
}

const DataGridRow = <TData extends DataGridRowProps>({ row, isSelected, setActiveRow, children, getRowProps, index }: Props<TData>) => {
    const rowProps = getRowProps ? getRowProps(row) : {};

    const onRowClick = (e: React.MouseEvent<HTMLDivElement>) => {
        const target = e.target as HTMLElement;
        if (target.closest('button') || target.closest('a') || target.closest('.form__checkbox-shadow') || target.closest('input')) {
            return;
        }

        if (!setActiveRow) {
            return;
        }

        setActiveRow(row.id, index);
    };

    return (
        <div
            {...rowProps}
            {...(row.original.wf_highlightcolor ? { style: { backgroundColor: row.original.wf_highlightcolor } } : {})}
            className={classNames('dataGrid__tr', rowProps.className, {
                'dataGrid__tr--active': isSelected,
            })}
            onClick={onRowClick}
        >
            {children}
        </div>
    );
};

export default memo(DataGridRow) as typeof DataGridRow;
